<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-row
      class="alternatingContentRow pa-0"
    >
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8 pb-0"
    >
      <v-col
        class="center"
        cols="12"
        lg="10"
      >
        <h2
          class="colorPrimary text-center"
        >
          Teksten uitvaart
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8"
    >
      <v-col
        class="center mt-5"
        cols="12"
        lg="6"
      >
        <h2
          class="text-center"
        >
          1. Levensverhaal
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8"
    >
      <v-col
        class="center mt-5"
        cols="12"
        lg="4"
      >
        <h2
          class="text-center"
        >
          2. Persoonlijke teksten
        </h2>
        <p
          class="text-center"
        >
          U kan uw persoonlijke teksten en/of een gedicht uit onze gedichtenbundel toevoegen zodat deze in de uitvaart kunnen opgenomen worden.
          <br>
          Wijzigingen via uw persoonlijk account kunnen tot twee dagen voor de uitvaart.
          <br>
          Hierna toch nog een wijziging? Neem gerust telefonisch contact met ons op.
        </p>
        <template
          v-if="false"
        >
          <p
            class="text-center"
          >
            Gelieve uw teksten voor de uitvaart definitief goed te keuren.
            <br>
            Wenst u nog iets te wijzigen dan kan dit nog tot twee dagen voor de uitvaart.
          </p>
          <p
            class="text-center"
          >
            Hiervoor heeft u Acrobat Reader nodig.
            U kan dit gratis <a class="secondaryLink" href="https://get.adobe.com/nl/reader/" target="_blank">downloaden</a>.
          </p>
        </template>
        <v-row
          class="mt-5"
        >
          <v-col
            class="center"
            cols="12"
            lg="12"
          >
            <template
              v-for="(tekst, index) in data.teksten"
              :key="index"
            >
              <v-form
                v-model="tekst.validForm"
                :ref="`formPersoonlijkeTeksten-${index}`"
              >
                <v-row>
                  <v-col
                    class="font-weight-bold py-2"
                    cols="12"
                    lg="3"
                  >
                    <v-tooltip
                      v-if="!tekst.valid"
                      location="start"
                      text="Niet alle velden zijn correct ingevuld."
                    >
                      <template
                        v-slot:activator="{ props }"
                      >
                        <v-icon
                          color="primary"
                          class="clickAction float-right"
                          style="margin-right:-20px"
                          v-bind="props"
                        >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    class="py-0"
                    cols="12"
                    lg="9"
                  >
                    <div
                      class="clickAction px-5 py-2 collapsableListItem"
                      :class="Expanded(tekst) ? 'pb-8' : 'pb-5'"
                      @click="CollapseOrExpand(tekst)"
                    >
                      <span>
                        {{ tekst.voornaam || tekst.familienaam ? `${tekst.voornaam ?? ''} ${tekst.familienaam ?? ''}` : '-' }}
                      </span>
                      <v-icon
                        class="clickAction float-right"
                      >
                        mdi-chevron-{{Expanded(tekst) ? 'up' : 'down'}}
                      </v-icon>
                      <v-icon
                        v-if="!tekst.idDossierUitvaartTekst || tekst.idDossierUitvaartTekst === constantMixin.guids.empty"
                        class="clickAction float-right"
                        size="small"
                        style="margin-top: 2px; margin-bottom: 10px;"
                        @click="DeleteTekst(tekst)"
                      >
                        mdi-close
                      </v-icon>
                    </div>
                  </v-col>
                  <template
                    v-if="Expanded(tekst)"
                  >
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    >
                      Deze tekst is van
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          lg="6"
                        >
                          <v-text-field
                            v-model="tekst.familienaam"
                            base-color="primary"
                            bg-color="white"
                            class="mt-3"
                            color="primary"
                            density="compact"
                            label="Uw naam"
                            variant="outlined"
                            :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                        >
                          <v-text-field
                            v-model="tekst.voornaam"
                            base-color="primary"
                            bg-color="white"
                            class="mt-3"
                            color="primary"
                            density="compact"
                            label="Uw voornaam"
                            variant="outlined"
                            :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                          />
                        </v-col>
                      </v-row>
                      <v-text-field
                        v-model="tekst.relatie"
                        base-color="primary"
                        bg-color="white"
                        color="primary"
                        density="compact"
                        label="Uw relatie tot de overledene"
                        variant="outlined"
                        ref="txtRelatie"
                        :rules="[validationMixin.rules.required]"
                      />
                    </v-col>
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    >
                      Tekst uploaden
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <control-input
                        v-model="tekst.bestandUitvaartTekst"
                        :accept="['doc', 'docx']"
                        dense
                        label="Toegelaten bestandstypes: doc, docx"
                        :maxFileSize="2"
                        :maxFileSizeText="textMixin.messages.maxFileSize"
                        outlined
                        @change="tekst.bestandUitvaartTekst.isEdited = true"
                        @clear="BestandClear(tekst)"
                        @download="Download(tekst)"
                        @data="tekst.bestandUitvaartTekst.blobDataString = $event"
                        @name="tekst.bestandUitvaartTekst.bestandsnaam = $event"
                      />
                    </v-col>
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    >
                      Tekst ingeven
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <v-textarea
                        v-model="tekst.tekst"
                        auto-grow
                        base-color="primary"
                        bg-color="white"
                        color="primary"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    >
                      Gedicht kiezen
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <v-text-field
                        v-model="tekst.gedicht.naam"
                        base-color="primary"
                        bg-color="white"
                        color="primary"
                        density="compact"
                        variant="outlined"
                        readonly
                        ref="txtRelatie"
                      >
                        <template
                          v-slot:append-inner
                        >
                          <v-btn
                            color="primary"
                            size="x-small"
                            style="margin-top: 2px"
                            @click="GedichtOpen()"
                          >
                            Kies
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    />
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <v-textarea
                        v-model="tekst.opmerking"
                        auto-grow
                        base-color="primary"
                        bg-color="white"
                        color="primary"
                        density="compact"
                        label="Plaats hier eventuele extra opmerkingen"
                        variant="outlined"
                      />
                    </v-col>
                    <v-col
                      class="font-weight-bold py-2 colorPrimary"
                      cols="12"
                      lg="3"
                    >
                      Voorgelezen door
                    </v-col>
                    <v-col
                      class="py-0"
                      cols="12"
                      lg="9"
                    >
                      <v-row
                        class="mt-0"
                      >
                        <v-col
                          cols="12"
                          lg="6"
                        >
                          <v-radio-group
                            v-model="tekst.voorgelezenDoor"
                            :rules="[validationMixin.rules.requiredCheckbox]"
                          >
                            <v-radio
                              :value="constantMixin.codes.voorgelezenDoor.values.dePersoonZelf"
                              base-color="primary"
                              bg-color="white"
                              color="primary"
                              label="De persoon zelf"
                              variant="outlined"
                            />
                          </v-radio-group>
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                        >
                          <v-radio-group
                            v-model="tekst.voorgelezenDoor"
                            :rules="[validationMixin.rules.requiredCheckbox]"
                          >
                            <v-radio
                              :value="constantMixin.codes.voorgelezenDoor.values.deVoorganger"
                              base-color="primary"
                              bg-color="white"
                              color="primary"
                              label="De voorganger"
                              variant="outlined"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </template>
                </v-row>
              </v-form>
            </template>
          </v-col>
          <v-col
            class="font-weight-bold py-2"
            cols="12"
            lg="3"
          />
          <v-col
            class="py-0"
            cols="12"
            lg="9"
            style="margin-top:-12px;"
          >
            <div
              class="py-2 collapsableListItem"
            >
              <v-row
                class="mt-3"
              >
                <v-col
                  cols="12"
                  lg="6"
                >
                  <v-btn
                    block
                    color="primary"
                    tile
                    @click="NieuweTekst()"
                  >
                    Tekst toevoegen
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  lg="6"
                >
                  <v-btn
                    block
                    color="primary"
                    :disabled="!TekstenValid"
                    tile
                    @click="SaveTeksten()"
                  >
                    Teksten opslaan
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      width="800"
    >
      <v-card
        class="px-3 py-5"
      >
        <h2
          class="colorPrimary text-center"
        >
          Gedichtenbundel
        </h2>
        <p
          class="text-center"
        >
          U kan een gedichtje kiezen of zich laten inspireren.
        </p>
        <v-row
          class="mt-5"
        >
          <v-col
            v-for="(item, index) in gedichten"
            :key="index"
            class="px-10 pt-5"
            :class="item.idGedicht === expanded.gedicht.idGedicht ? 'elementSelected' : ''"
            cols="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                lg="12"
              >
                <span
                  class="colorPrimary volgnummer"
                >
                  {{item.volgnummer}}
                </span>
                <p
                  style="white-space: pre-line"
                >
                  {{ item.tekst }}
                  <br>
                  <span
                    class="font-italic"
                  >
                    {{ item.auteur }}
                  </span>
                </p>
              </v-col>
              <v-col
                cols="6"
                lg="8"
              >
                <div
                  style="border-bottom: 1px solid #AAAAAA; margin-top: 35px;"
                />
              </v-col>
              <v-col
                cols="6"
                lg="4"
              >
                <v-btn
                  block
                  color="primary"
                  :disabled="item.idGedicht === expanded.gedicht.idGedicht"
                  tile
                  @click="GedichtSelecteer(item)"
                  >
                  Kies
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import blobMixin from '@/mixins/blobMixin'
import errorMixin from '@/mixins/errorMixin'
import validationMixin from '@/mixins/validationMixin'
import ControlInput from './ControlInput.vue'
import blobService from '@/services/blobService'
import klantService from '@/services/klantService'

export default {
  name: 'RouwdrukwerkComponent',
  mixins: [
    authenticationMixin,
    blobMixin,
    errorMixin,
    validationMixin
  ],
  components: {
    ControlInput
  },
  data () {
    return {
      dialog: false,
      expandAll: false,
      expanded: null,
      gedichten: [],
      nieuweTekst: null,
      data: {
        teksten: []
      }
    }
  },
  async mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    blobService.Init(this)
    klantService.Init(this)
    this.$store.state.headers.samenstellen = true
    await this.GetGedichtList()
    await this.GetTekstenList()
    await this.GetTekstenDetail()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  watch: {
    'expanded.validForm' (value) {
      if (this.expanded) {
        this.expanded.valid = value
      }
    }
  },
  computed: {
    TekstenValid () {
      return this.data.teksten.every(tekst => tekst.valid)
    }
  },
  methods: {
    BestandClear (tekst) {
      tekst.bestandUitvaartTekst.blobDataString = null
      tekst.bestandUitvaartTekst.bestandsnaam = null
    },
    async CollapseOrExpand (tekst) {
      if (this.expanded === tekst) {
        this.expanded = null
      } else {
        this.expanded = tekst
      }
    },
    DeleteTekst (tekst) {
      if (this.CommonMixin_Confirmation(!tekst.idDossierUitvaartTekst || tekst.idDossierUitvaartTekst === this.constantMixin.guids.empty, this.textMixin.messages.deleteConfirmation.replaceAll('@@item', 'deze tekst'), false)) {
        const index = this.data.teksten.indexOf(tekst)
        if (index > -1) {
          this.data.teksten.splice(index, 1)
        }
      }
    },
    async Download (tekst) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await blobService.Download(tekst.bestandUitvaartTekst.idBlob)

      if (resp && (resp.data || resp.data !== '')) {
        this.BlobMixin_DownloadAction(tekst.bestandUitvaartTekst.bestandsnaam, null, resp.data)
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    Expanded (tekst) {
      return this.expandAll || this.expanded == tekst
    },
    GedichtOpen () {
      this.dialog = true
    },
    GedichtSelecteer (gedicht) {
      this.expanded.gedicht = gedicht
      this.expanded.idGedicht = gedicht.idGedicht
      this.dialog = false
    },
    async GetGedichtList () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartGedichtList()

      if (resp && (resp.data || resp.data !== '')) {
        this.gedichten = this.CommonMixin_Clone(resp.data)
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetTekstenDetail () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartTekstenDetail(this.constantMixin.guids.empty)

      if (resp && (resp.data || resp.data !== '')) {
        this.nieuweTekst = this.CommonMixin_Clone(resp.data)
        this.$forceUpdate()
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetTekstenList () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartTekstenList()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = this.CommonMixin_Clone(resp.data)
        this.$forceUpdate()
        await this.ValidateTeksten()
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    NieuweTekst () {
      this.data.teksten.push(this.CommonMixin_Clone(this.nieuweTekst))
      this.$forceUpdate()
    },
    async SaveTeksten () {
      await this.ValidateTeksten()
      if (this.TekstenValid) {
        this.CommonMixin_Load(this.$options.name, true)
        await klantService.SaveUitvaartTeksten(this.data)
        this.CommonMixin_Load(this.$options.name, false)
        await this.GetTekstenList()
      }
    },
    async ValidateTekst (tekst, index) {
      const validationResult = await this.$refs[`formPersoonlijkeTeksten-${index}`][0].validate()
      tekst.valid = validationResult.valid
    },
    async ValidateTeksten () {
      this.expandAll = true
      setTimeout(() => {
        this.data.teksten.forEach(async (tekst, index) => {
          await this.ValidateTekst(tekst, index)
          this.expandAll = false
        })
      }, 1)
    }
  }
}
</script>
